import type { IconDefinition } from '../../types'

export default {
  details: [256, 512, [], '', 'M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z'],
  name: 'uiAngleUp',
  oldName: 'falAngleUp'
} as IconDefinition
